import { ReactComponent as IconDocuments } from '@assets/icons/documents.svg';
import list from './DocumentsPage';

export default { list, icon: IconDocuments };
